// TODO: These schemas are hardcoded based on the Gundi API v2 documentation
// (POST /v2/observations/ and POST /v2/events/). They should be fetched
// dynamically from the backend API once a dedicated endpoint is available
// (e.g. /v2/schemas/observation, /v2/schemas/event, or via the OpenAPI spec).
// See: https://api.stage.gundiservice.org/v2/docs/ (requires auth)

export type FieldSpec = {
  key: string;
  labelKey: string;
  required: boolean;
  description?: string;
  type?: string;
  literalInput?: boolean;
  showInCore?: boolean;
};

export type GundiObjectSpec = {
  labelKey: string;
  fields: FieldSpec[];
};

const OBSERVATION_FIELDS: FieldSpec[] = [
  {
    key: 'source',
    labelKey: 'source',
    required: true,
    description: 'Source identifier (e.g. device ID)',
    type: 'string',
  },
  {
    key: 'recorded_at',
    labelKey: 'recorded_at',
    required: true,
    description: 'Timestamp (ISO 8601)',
    type: 'string',
  },
  {
    key: 'location.lat',
    labelKey: 'location.lat',
    required: true,
    description: 'Latitude',
    type: 'number',
  },
  {
    key: 'location.lon',
    labelKey: 'location.lon',
    required: true,
    description: 'Longitude',
    type: 'number',
  },
  {
    key: 'type',
    labelKey: 'type',
    required: false,
    description: 'Observation type (e.g. tracking-device)',
    type: 'string',
  },
  {
    key: 'source_name',
    labelKey: 'source_name',
    required: false,
    showInCore: true,
    description: 'Source name',
    type: 'string',
  },
  {
    key: 'subject_type',
    labelKey: 'subject_type',
    required: false,
    showInCore: true,
    literalInput: true,
    description: 'Subject type (e.g. giraffe)',
    type: 'string',
  },
  {
    key: 'additional',
    labelKey: 'additional',
    required: false,
    description: 'Additional key-value data',
    type: 'object',
  },
  {
    key: 'annotations',
    labelKey: 'annotations',
    required: false,
    description: 'Annotation metadata',
    type: 'object',
  },
];

const EVENT_FIELDS: FieldSpec[] = [
  {
    key: 'event_type',
    labelKey: 'event_type',
    required: true,
    literalInput: true,
    description: 'Event type (e.g. animal_sighting)',
    type: 'string',
  },
  {
    key: 'recorded_at',
    labelKey: 'recorded_at',
    required: true,
    description: 'Timestamp (ISO 8601)',
    type: 'string',
  },
  {
    key: 'location.lat',
    labelKey: 'location.lat',
    required: true,
    description: 'Latitude',
    type: 'number',
  },
  {
    key: 'location.lon',
    labelKey: 'location.lon',
    required: true,
    description: 'Longitude',
    type: 'number',
  },
  {
    key: 'title',
    labelKey: 'title',
    required: false,
    showInCore: true,
    description: 'Event title',
    type: 'string',
  },
  {
    key: 'event_details',
    labelKey: 'event_details',
    required: false,
    description: 'Event-specific data',
    type: 'object',
  },
  {
    key: 'geometry',
    labelKey: 'geometry',
    required: false,
    description: 'GeoJSON polygon',
    type: 'object',
  },
  {
    key: 'annotations',
    labelKey: 'annotations',
    required: false,
    description: 'Annotation metadata',
    type: 'object',
  },
  {
    key: 'status',
    labelKey: 'status',
    required: false,
    description: 'Event status',
    type: 'string',
  },
];

export const GUNDI_OBJECT_SPECS: Record<string, GundiObjectSpec> = {
  obv: { labelKey: 'Observation', fields: OBSERVATION_FIELDS },
  ev: { labelKey: 'Event', fields: EVENT_FIELDS },
};
